import {Navigate, Outlet} from 'react-router-dom';
import {useAuth} from './AuthProvider';
import Spinner from "../ui/Spinner";
import React from "react";


interface ProtectedRouteProps {
    roles?: string[];
}

const ProtectedRoute = ({ roles = [] } : ProtectedRouteProps) => {

    const {userAccount, loading, hasAuthority} = useAuth();

    if (loading) {
        return <Spinner/>;
    }

    if (!userAccount) {
        return <Navigate to="/login" replace/>;
    }

    if (roles.length === 0) {
        return <Outlet />;
    }

    const hasRequiredAuthority = roles.some(role => hasAuthority(role));

    if (!hasRequiredAuthority) {
        return <Navigate to="/unauthorized" replace />;
    }

    // User is authenticated and has required role, render the protected component
    return <Outlet />;
};

export default ProtectedRoute;